<template>
  <div class="flex flex-col gap-y-3 items-start justify-start relative overflow-y-auto content-scroll pr-1 pl-6 py-6">
    <div class="flex items-center justify-end px-2 w-full">
      <button @click="closeSidebar">
        <WcIconCross
          class="h-6"
        />
      </button>
    </div>
    <div v-if="userRole === RolesEnum.INTERNAL_WC_SALES || userRole === RolesEnum.INTERNAL_PARTNER_SALES">
      <WcTypography title="My Companies" size="xs" weight="600" color="#010113" class="relative self-stretch uppercase" />
    </div>
    <div class="flex flex-col gap-y-2 items-start justify-start self-stretch shrink-0 relative" v-for="route in routes" :key="route.path">
      <WcTypography :title="route.meta.title" size="xs" weight="600" color="#010113" class="relative self-stretch uppercase" v-if="(route.meta.roles).indexOf(userRole) > -1 && userRole === RolesEnum.INTERNAL_SUPER_ADMIN" />
      <div class="w-full" v-if="(route.meta.roles).indexOf(userRole) > -1">
        <div class="w-full" v-for="child in route.children"
        :key="child.path">
          <div class="flex flex-col items-start justify-start self-stretch shrink-0 relative gap-y-1"  v-if="(child.meta.roles).indexOf(userRole) > -1">
            <LinkButton
              :link="{
                name: child.meta.title,
                to: `${route.path}/${child.path}`,
                active: `${route.path}/${child.path}`
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { ADMIN_ROUTES } from '@/routes/admin-routes'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import Button from '@/components/UILibrary/Buttons/Button.vue'
import WcIconCross from '@/components/UILibrary/Icons/WcIconCross.vue'
import { AppModule } from '@/store/modules/app'
import { RouteConfig } from 'vue-router'
import { UserModule } from '@/store/modules/user'
import { RolesEnum } from '@/views/recruiter/models/roles-model'

@Component({
  name: 'SideBar',
  components: {
    WcIconCross,
    Button,
    WcTypography
  }
})
export default class extends Vue {
  UserModule = UserModule
  RolesEnum = RolesEnum

  get routes(): RouteConfig[] {
    return ADMIN_ROUTES
  }

  get userRole(): string {
    return this.UserModule.roles[0]
  }

  closeSidebar() {
    AppModule.CloseSideBar(false)
  }
}
</script>
